import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getKpisList = async (dataOrigen, refrescar, api, token, body, config, rol_user_SEND, user_superuser) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.kpis_list.length <= 0 || data.date_from !== config.startDate || data.date_to !== config.endDate) {
    const response = await axios(configws)
    data = {  kpis_list: base64ToString(response) }
  }

    // eslint-disable-next-line object-curly-newline
    const { q = '', perPage = 10, page = 1, sort, sortColumn, pageAsi } = config
    /* eslint-enable */
    const dataAsc = data.kpis_list.sort((a, b) => {
      if (a[sortColumn]) {
        return a[sortColumn] < b[sortColumn] ? 1 : -1
      } else {
        const splitColumn = sortColumn.split('.')
        const columnA = a[splitColumn[0]][splitColumn[1]]
        const columnB = b[splitColumn[0]][splitColumn[1]]
        return columnA < columnB ? 1 : -1
      }
    })
    

    if (rol_user_SEND === 'superuser' && user_superuser === 1) {

    const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

    const queryLowered = q.toLowerCase()
    const filteredData = dataToFilter.filter(kpis_lists => {

        return (
          (
            (kpis_lists.nombre && String(kpis_lists.nombre).toLowerCase().includes(queryLowered))
          ) 
        )
    })

    return [
      200,
      {
        allData: data.kpis_list,
        total: filteredData.filter((item) => (item.role !== 3)).length,
        total_asi: filteredData.filter((item) => (item.role === 3)).length,
        kpis_list: filteredData.filter((item) => (item.role !== 3)).length <= perPage ? filteredData.filter((item) => (item.role !== 3)) : paginateArray(filteredData.filter((item) => (item.role !== 3)), perPage, page),
        kpis_list_asi: filteredData.filter((item) => (item.role === 3)).length <= perPage ? filteredData.filter((item) => (item.role === 3)) : paginateArray(filteredData.filter((item) => (item.role === 3)), perPage, pageAsi)
      }
    ]  
  }

  if (rol_user_SEND === 'gerente' || rol_user_SEND === 'ejecutivo') {

    const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

    const queryLowered = q.toLowerCase()
    const filteredData = dataToFilter.filter(kpis_lists => {

        return (
          (
            (kpis_lists.nombre && String(kpis_lists.nombre).toLowerCase().includes(queryLowered))
          ) 
        )
    })

    return [
      200,
      {
        allData: data.kpis_list,
        total: filteredData.length,
        total_asi: filteredData.length,
        kpis_list: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
        kpis_list_asi: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
      }
    ]  
  }
}

// ------------------------------------------------
// GET: Return closure List for Comission
// ------------------------------------------------
let dataKpis = JSON.parse(localStorage.getItem("dataKpis")) || { kpis_list: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1}

mock.onGet('/apps/kpislist/list').reply(async config => {

  const user = getUserData()

  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = ''

  const user_rol = user.usercoc.role
  const user_superuser  = user.usercoc.superuser

  let rol_user_SEND = ''

  if (user_rol === 1 && user_superuser === 1) {
    rol_user_SEND = 'superuser'
  } else if (user_rol === 1 && user_superuser === 0) {
    rol_user_SEND = 'gerente'
  } else {
    rol_user_SEND = 'ejecutivo'
  }

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      cluster_id = config.cluster_id
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
    }
      
    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_select
    }

  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country
    user_id    = user.usercoc.username
  }
  
  const body = {
    internal_closure_id:    "",
    cluster:                cluster_id,
    country:                country_id,
    office:                 office_id,
    user:                   user_id,
    date_from:              config.startDate,
    date_to:                config.endDate
  }

  if (localStorage.getItem("resetKpis")) {
    if (localStorage.getItem("resetKpis") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetKpis")
  }

  const now = new Date()
  const diffInMinutes = (now - dataKpis.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataKpis = { kpis_list: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const result = await getKpisList(dataKpis, 1, GetApiCOC('getKpisInfo'), user.token, body, config, rol_user_SEND, user_superuser)

  dataKpis = { kpis_list: result[1].allData, date_from: config.startDate, date_to: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id }

  localStorage.setItem("dataKpis", JSON.stringify(dataKpis))

  return result
})
